export enum DivorceEnum {
    'OUI', 'NON'
}
